import {
  AuditOutlined,
  BorderlessTableOutlined,
  BorderOutlined,
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PercentageOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { CONFIG } from '../constants';

export const InputIconEdit = ({ onClick, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Editar">
      <EditOutlined onClick={onClick} style={{ color: 'rgba(0,0,0,.45)' }} />
    </Tooltip>
  );
};

export const InputIconAutorizar = ({ onClick, loading, active }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Autorización">
      <AuditOutlined
        onClick={onClick}
        style={{ color: active ? CONFIG.COLOR_PRIMARY : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

export const InputIconRecargo = ({ onClick, loading, active }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Recargo">
      <PercentageOutlined
        onClick={onClick}
        style={{ color: active ? CONFIG.COLOR_PRIMARY : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

export const InputIconCostoAdicional = ({ onClick, loading, active }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Costo Adicional por Ocupante">
      <BorderOutlined
        onClick={onClick}
        style={{ color: active ? CONFIG.COLOR_PRIMARY : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

export const InputIconCostoMinimo = ({ onClick, loading, active }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Costo mínimo">
      <BorderlessTableOutlined
        onClick={onClick}
        style={{ color: active ? CONFIG.COLOR_PRIMARY : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

export const InputIconCobertura = ({ onClick, loading, active }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Coberturas">
      <UnorderedListOutlined
        onClick={onClick}
        style={{ color: active ? CONFIG.COLOR_PRIMARY : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

export const InputIconEliminar = ({ onClick, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Button
      type="text"
      icon={<DeleteOutlined />}
      size="middle"
      onClick={onClick}
      style={{ color: 'rgba(0,0,0,.45)' }}
    />
  );
};
